<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-book`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4c1.661 0 3 1.352 3 3.01v28.404a3.02 3.02 0 01-2.106 2.873L24.88 43.822a3 3 0 01-1.762 0L5.076 38.278A3.01 3.01 0 013 35.414V7.01a3.005 3.005 0 013.893-2.874L24 9.382l17.076-5.236C41.374 4.05 41.686 4 42 4zM7 8.353v26.332l15 4.608v-26.34l-15-4.6zm19 4.599l15-4.6v26.333l-15 4.608V12.952z"/></svg>
</template>
<script>

export default {
  name: 'IconBook',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
